export const MASTER = 'MASTER';
export const SLAVE = 'SLAVE';
export const NONE = 'NONE';
      
